// extracted by mini-css-extract-plugin
export var thirdSection = "thirdSection-module--thirdSection--15gdB";
export var title = "thirdSection-module--title--2WBoK";
export var img = "thirdSection-module--img--alEpz";
export var description = "thirdSection-module--description--2_HS6";
export var emblemItems = "thirdSection-module--emblemItems--1583b";
export var item = "thirdSection-module--item--14T3O";
export var spaseToTop = "thirdSection-module--spaseToTop--Ns6od";
export var ozon = "thirdSection-module--ozon--1sduP";
export var medsvc = "thirdSection-module--medsvc--2iVhO";